import React, { Component } from "react";
import { Helmet } from "react-helmet";
import AuthorProfileView from "./view/author-profile.jsx";

class AuthorProfilePage extends Component {
  render() {
    return (
      <div>
        <Helmet title="Author Profile | PubNinja - You Publish. The rest we manage." />
        <AuthorProfileView />
      </div>
    );
  }
}

export default AuthorProfilePage;
